// Le filet sous les écrans : ce qui s'affiche quand l'un d'eux lève une
// erreur pendant son rendu.
//
// Sans lui, React démonte tout l'arbre et l'utilisateur se retrouve devant
// une page blanche, sans message ni moyen de repartir. Le routeur pose ce
// filet sur chaque écran (voir cabinetRoutes) : l'erreur reste dans le creux de
// la coquille, le rail continue de répondre, et une seule route est perdue.
//
// C'est le pendant compta du GlobalErrorFallback de Dust, avec nos briques.

import "./ecran-interrompu.css";

import { Bouton } from "@app/components/compta/ui/Bouton";
import { ComptaIcone } from "@app/components/compta/ui/ComptaIcone";
import { useEffect } from "react";
import { useRouteError } from "react-router-dom";

import { useNavigationCompta } from "./useNavigationCompta";

interface EcranInterrompuProps {
  // Vrai quand la coquille elle-même est tombée : il n'y a plus de rail
  // autour, le filet occupe alors toute la fenêtre.
  pleinEcran?: boolean;
}

export function EcranInterrompu({ pleinEcran }: EcranInterrompuProps) {
  const erreur = useRouteError();
  // Le même retour que la flèche de la coquille : le portefeuille du cabinet.
  const { revenirAuPortefeuille } = useNavigationCompta();

  useEffect(() => {
    // Remonte à la console du navigateur, donc à la collecte d'erreurs
    // côté client : inutile de journaliser une seconde fois.
    console.error("Écran interrompu :", erreur);
  }, [erreur]);

  return (
    <div
      className={pleinEcran ? "cinterrompu cinterrompu--plein" : "cinterrompu"}
      role="alert"
    >
      <ComptaIcone nom="info" taille={28} className="cinterrompu__icone" />
      <h2 className="cinterrompu__titre">Cet écran s&apos;est interrompu.</h2>
      <p className="cinterrompu__phrase">
        Rien n&apos;a été perdu de votre côté. Rechargez pour repartir sur un
        écran propre ; si cela se reproduit au même endroit, signalez-le.
      </p>
      <div className="cinterrompu__actions">
        <Bouton
          icone="arrows-clockwise"
          libelle="Recharger"
          onClick={() => window.location.reload()}
        />
        <Bouton
          variante="contour"
          libelle="Revenir au portefeuille"
          onClick={revenirAuPortefeuille}
        />
      </div>
    </div>
  );
}
